import React from 'react';
import { renderIconByLabel } from '../../content/icons';

export const ConditionBig = props => {
  const { condition, updateField, canInteract = true } = props;
  const iconName = condition?.[condition?.state]?.icon;
  const iconElement = iconName ? renderIconByLabel(iconName, { size: 20 }) : null;
  const label = condition?.[condition?.state]?.label;

  return (
    <div
      onClick={() =>
        canInteract &&
        updateField(
          condition.state === 'active' ? 'inactive' : 'active',
          'state'
        )
      }
      className={`w-full rounded shadow px-1 py-03 my-1 text-center uppercase font-condensed font-bold overflow-hidden ${
        canInteract ? 'cursor-pointer transition hover:opacity-50' : 'cursor-default'
      } ${
        condition?.state === 'active' ? 'bg-secondary-d' : 'bg-primary'
      }`}
    >
      <div className='flex items-center justify-center gap-05'>
        {iconElement && <span className='inline-flex'>{iconElement}</span>}
        {label && <span>{label}</span>}
      </div>
    </div>
  );
};
